// It supports converting both camelCase and PascalCase into kebab-case
export function toKebabCase(str: string): string {
    return str?.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
